import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
  signal,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  DxAutocompleteModule,
  DxButtonModule,
  DxLoadPanelModule,
  DxPopupModule,
} from "devextreme-angular";
import { SelectionChangedEvent } from "devextreme/ui/autocomplete";
import { take } from "rxjs";
import { DelegateService } from "../../../core/services/delegate.service";
import { SignalService } from "../../../core/services/loader.service";
import { showNotification } from "../../../core/utils/toast";
import { AgreementHeader } from "../../../domain/models/agreement.model";
import { GetAllActivePEUseCase } from "../../../domain/use-cases/hr/get-all-active-pe.usecase";
import moment from "moment";

interface User {
  rinaId: string;
  userRole: string;
}

@Component({
  selector: "app-modal-delegate",
  standalone: true,
  imports: [
    FormsModule,
    DxAutocompleteModule,
    DxPopupModule,
    DxButtonModule,
    DxLoadPanelModule,
  ],
  templateUrl: "./modal-delegate.component.html",
  styleUrls: ["./modal-delegate.component.scss"],
})
export class ModalDelegateComponent implements OnChanges {
  private delegateService = inject(DelegateService);
  public signalService = inject(SignalService);
  @Input() isPopupVisible: boolean = false;
  @Input() user: User = { rinaId: "", userRole: "" };
  @Output() closeModalEmitter = new EventEmitter<boolean | null>();

  resourcesOptions: any = [];

  delegateList = signal<any[]>([]);

  projectInfo: AgreementHeader = {
    projectEngineer: { id: 0, fullname: "" },
    customer: "",
    notes: "",
    startDate: moment(), // oppure una data fissa, ad es. new Date('2024-11-07')
    endDate: moment(),
    smartStartDate: moment(),
    smartEndDate: moment(),
    winProbability: 0,
    clm: { externalSource: 0, externalSourceDesc: "" },
    externalCode: "",
    owner: "",
    oppportunityCode: "",
  };

  constructor(private getAllResources: GetAllActivePEUseCase) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["isPopupVisible"] &&
      changes["isPopupVisible"].currentValue === true
    ) {
      this.getAll();
      this.getDelegateList();
    }
  }

  selectedPe(selectValue: SelectionChangedEvent) {
    if (selectValue.selectedItem) {
      this.projectInfo.projectEngineer = {
        id: selectValue.selectedItem.id,
        fullname:
          this.resourcesOptions.find(
            (res: any) => res.id === selectValue.selectedItem.id,
          )?.name ?? "",
      };
    }
  }

  onCloseModal(): void {
    this.closeModalEmitter.emit(false);
    this.resetForm();
  }

  resetForm() {
    this.projectInfo.projectEngineer = { id: 0, fullname: "" };
  }

  getAll() {
    const today = moment();
    const year = today.get('year');
    const month = String(today.get('month') + 1).padStart(2, "0");
    const day = String(today.get('date')).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    this.signalService.loadingSignal.set(true);
    this.getAllResources
      .execute({
        startDate: formattedDate,
        endDate: formattedDate,
      })
      .subscribe((resources) => {
        this.signalService.loadingSignal.set(false);
        this.resourcesOptions = resources.map((el) => ({
          id: el.id,
          name: `${el.name} ${el.surname}`,
        }));
      });
  }

  addDelegate() {
    const delegato = {
      ...this.projectInfo.projectEngineer,
      delegateId: this.user?.rinaId,
      delegateRole: this.user?.userRole,
    };
    const userFind = this.delegateList().findIndex(
      (item) => item.id === this.projectInfo.projectEngineer.id,
    );
    if (userFind === -1) {
      this.delegateList.update((delegate) => [...delegate, delegato]);

      const addDelegato = {
        delegation: {
          rinaId: this.user?.rinaId,
          resourceDelegated: delegato.id,
          resourceFullName: delegato.fullname,
        },
      };
      this.delegateService.addDelegate(addDelegato).subscribe({
        next: (res: any) => {
          console.log(res);
          this.getDelegateList();

          if (!res?.result) {
            showNotification("Error in assigning delegation", "error");
          }
        },
        error: (e) => console.log(e),
      });
    } else {
      showNotification("Already existing delegate", "warning");
    }

    this.projectInfo.projectEngineer = { id: 0, fullname: "" };
  }

  removeDelegate(delegato: any) {
    this.delegateService
      .deleteDelegate(delegato.rinaId, delegato.resourceDelegated)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          this.getDelegateList();

          if (!res?.result) {
            showNotification("Error deleting delegation", "error");
          }
        },
        error: (e) => console.log(e),
      });
  }

  getDelegateList() {
    this.delegateService
      .getAllDelegate(this.user?.rinaId)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          console.log(res);
          this.delegateList.set(res.delegation);
        },
        error: (e) => {
          console.log(e),
            showNotification("Error retrieving the list of delegates", "error");
        },
      });
  }
}
